import axios from 'axios';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/stat/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/stat/';

class StatService {

  // This will get all stats in Player/Team Radars, or in Player Scout excluding Scores
  getAll() {
    return axios.get(
      API_URL
    )
  }

  getGameStats() {
    return axios.get(
      API_URL + "game-stats"
    )
  }

  getStatsOfRadar(radarId) {
    return axios.get(
      API_URL + "radar/" + radarId
    )
  }

  getAdminStats(components,dayOffset = 0,showApi = true) {
    return axios.get(
      API_URL + "admin",{
        params:{components:components.join(","),showApi,dayOffset}
      }
    )
  }

  getUserStats(userId,period,components) {
    return axios.get(
      API_URL + "user/" + userId,{
        params:{
          time:period,
          components:components.join(",")
        }
      }
    )
  }

  getLoginStats() {
    return axios.get(
      API_URL + "admin/login"
    )
  }

  getClientStats(clientId,period){
    return axios.get(`${API_URL}${clientId}`,{params:{time:period}});
  }

  getAllClientStats(period){
    return axios.get(`${API_URL}clients`,{params:{time:period}});
  }

  getOnOffStats(teamId,gameIds,playersOn,playersOff,ground){
    return axios.get(`${API_URL}season/team/${teamId}/games/${gameIds}/players-on/${playersOn}/players-off/${playersOff}/ground/${ground}`);
  }

  getHotPlayers(period) {
    return axios.get(
      API_URL + "hot-players",{
        params:{
          time:period
        }
      }
    )
  }

  getMinMax(id){
    return axios.get(`${API_URL}${id}/min-max`);
  }

  getPlayerScoutStatsFilter(){
    return axios.get(
      `${API_URL}player-scout-stats-filter`
    )
  }

  getClientOverallPlayersStats(clientId) {
    return axios.get(`${API_URL}${clientId}/overall-players`);
  }

  getClientOverallStats(clientId) {
    return axios.get(`${API_URL}${clientId}/overall-stats`);
  }

  getHistoryStats(clientId) {
    return axios.get(`${API_URL}history`);
  }

}

export default new StatService();
